import { Icon, Label } from '@aibees/shared/components';
import { Stack, Typography } from '@mui/material';
import type { PlanCellValueProps as Props } from './types';

export function PlanCellValue({ value, subtext }: Props) {
  if (value === 'check') {
    return <Icon name="check-fill" size={22} color="primary.500" />;
  }
  if (value === 'dash') {
    return (
      <Typography variant="body2" color="text.disabled">
        —
      </Typography>
    );
  }
  if (value === 'comingSoon') {
    return (
      <Label color="default" variant="soft" size="small">
        Coming Soon
      </Label>
    );
  }
  return (
    <Stack alignItems="center">
      <Typography variant="body2" fontWeight={500} color="text.secondary">
        {value}
      </Typography>
      {subtext && (
        <Typography variant="body5" color="grey.500">
          {subtext}
        </Typography>
      )}
    </Stack>
  );
}
